// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"42c5a79f","453":"d855a71b","455":"2eabd8ec","900":"dcbe5038","977":"2caed02d"}[chunkId] + ".chunk.js";
};